"use strict";
const applyDangerStyleToConfirm = () => {
  const confirmButton = document.querySelector("[data-confirm-ok]");
  if (!confirmButton) {
    return;
  }
  confirmButton.classList.add("button__danger");
  confirmButton.classList.remove("button__secondary");
};
const resetConfirmButtonStyle = () => {
  const confirmButton = document.querySelector("[data-confirm-ok]");
  if (!confirmButton) {
    return;
  }
  confirmButton.classList.remove("button__danger");
};
document.addEventListener("click", (event) => {
  const target = event.target.closest("[data-confirm][data-confirm-danger]");
  if (!target) {
    return;
  }
  window.setTimeout(applyDangerStyleToConfirm, 0);
});
document.addEventListener("click", (event) => {
  if (event.target.closest("[data-confirm-cancel], [data-close], [data-confirm-ok]")) {
    resetConfirmButtonStyle();
  }
});
